<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Envanter Ekranı</v-toolbar-title>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="inventoryItems"
      :loading="loading"
      :rows-per-page-items="[50, 100, 500, { text: 'Tümü', value: -1 }]"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="px-2">{{ props.item.inventoryTypeName }}</td>
        <td class="px-2">{{ props.item.productName }}</td>
        <td class="px-2">{{ props.item.weight }}</td>
        <td class="px-2">{{ props.item.purityLabel }}</td>
        <td class="px-2">{{ props.item.size || '-' }}</td>
        <td class="px-2">{{ props.item.hasPerUnit.toFixed(4) }}</td>
        <td class="px-2">{{ props.item.quantity }}</td>
        <td class="px-2">{{ props.item.totalHas.toFixed(4) }}</td>
        <td class="px-2">
          <v-btn
            v-if="props.item.inventoryType === 0"
            small
            flat
            color="primary"
            @click="goToJewelryList(props.item)"
          >Liste</v-btn>
        </td>
      </template>
    </v-data-table>

    <!-- Alt Butonlar -->
    <v-layout wrap justify-space-between class="mt-3 px-2">
      <v-flex xs12 md8>
        <v-btn color="amber darken-2" dark @click="ziynetDialog = true" class="mb-2">
          <v-icon left>monetization_on</v-icon>
          Ziynet Ekle
        </v-btn>
        <v-btn color="blue-grey darken-1" dark @click="kulceDialog = true" class="mb-2">
          <v-icon left>view_in_ar</v-icon>
          Külçe Ekle
        </v-btn>
        <v-btn color="teal darken-1" dark @click="openTakiDialog" class="mb-2">
          <v-icon left>diamond</v-icon>
          Takı Ekle
        </v-btn>
      </v-flex>
      <v-flex xs12 md4 class="text-xs-right">
        <v-chip color="primary" text-color="white" large>
          <strong>Toplam Has: {{ totalHas.toFixed(4) }} gr</strong>
        </v-chip>
      </v-flex>
    </v-layout>

    <!-- ========== KÜLÇE EKLE DIALOG ========== -->
    <v-dialog v-model="kulceDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline blue-grey darken-1 white--text">
          <v-icon left color="white">view_in_ar</v-icon>
          Külçe Ekranı
        </v-card-title>
        <v-card-text class="pa-4">
          <v-combobox
            v-model="kulceForm.selectedProduct"
            :items="kulceProducts"
            item-text="label"
            item-value="weight"
            label="Ürün"
            return-object
          ></v-combobox>
          <v-text-field
            :value="kulceForm.selectedProduct ? kulceForm.selectedProduct.weight + ' gr' : ''"
            label="Ağırlık"
            readonly
          ></v-text-field>
          <v-combobox
            v-model="kulceForm.selectedPurity"
            :items="kulcePurities"
            item-text="label"
            item-value="value"
            label="Ayar"
            return-object
          ></v-combobox>
          <v-text-field
            :value="kulceHas"
            label="Has"
            readonly
            suffix="gr"
          ></v-text-field>
          <v-text-field
            v-model.number="kulceForm.quantity"
            label="Adet"
            type="number"
            min="1"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="kulceDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="kulceSaving" @click="saveKulce">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== ZİYNET EKLE DIALOG ========== -->
    <v-dialog v-model="ziynetDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline amber darken-2 white--text">
          <v-icon left color="white">monetization_on</v-icon>
          Ziynet Ekranı
        </v-card-title>
        <v-card-text class="pa-4">
          <v-combobox
            v-model="ziynetForm.selectedProduct"
            :items="ziynetProducts"
            item-text="label"
            item-value="name"
            label="Ürün"
            return-object
          ></v-combobox>
          <v-text-field
            :value="ziynetForm.selectedProduct ? ziynetForm.selectedProduct.weight + ' gr' : ''"
            label="Ağırlık"
            readonly
          ></v-text-field>
          <v-text-field
            :value="ziynetHas"
            label="Has"
            readonly
            suffix="gr"
          ></v-text-field>
          <v-text-field
            v-model.number="ziynetForm.quantity"
            label="Adet"
            type="number"
            min="1"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="ziynetDialog = false">İptal</v-btn>
          <v-btn color="primary" dark :loading="ziynetSaving" @click="saveZiynet">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========== TAKI EKLE DIALOG ========== -->
    <v-dialog v-model="takiDialog" max-width="900" persistent>
      <v-card>
        <v-card-title class="headline teal darken-1 white--text">
          <v-icon left color="white">diamond</v-icon>
          Takı Ekleme Ekranı
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeTakiDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-layout wrap>
            <!-- Sol: Form -->
            <v-flex xs12 md6 class="pr-3">
              <v-combobox
                v-model="takiForm.selectedProduct"
                :items="takiProducts"
                label="Ürün"
              ></v-combobox>
              <v-combobox
                v-model="takiForm.selectedSize"
                :items="takiSizes"
                label="Ölçü"
              ></v-combobox>
              <v-combobox
                v-model="takiForm.selectedPurity"
                :items="takiPurities"
                item-text="label"
                item-value="value"
                label="Ayar"
                return-object
              ></v-combobox>
              <v-layout align-center>
                <v-flex grow>
                  <v-text-field
                    :value="takiForm.weight != null ? takiForm.weight + ' gr' : 'Tartım bekleniyor...'"
                    label="Ağırlık"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex shrink class="ml-2">
                  <v-btn small color="teal" dark @click="readScaleForTaki" :loading="scaleLoading">
                    <v-icon small left>fitness_center</v-icon>
                    Tartımı Oku
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-text-field
                :value="takiHas"
                label="Has"
                readonly
                suffix="gr"
              ></v-text-field>
              <div v-if="takiRoundingDifferenceText" class="subtitle-1 py-2" style="color: #00695c;">
                {{ takiRoundingDifferenceText }}
              </div>
              <v-text-field
                :value="takiForm.serialNumber || 'Kayıt sonrası oluşur'"
                label="Seri No"
                readonly
              ></v-text-field>
              <div v-if="takiForm.serialNumber" class="mt-2 pa-2 text-center taki-barcode-box">
                <div class="caption grey--text">Barkod</div>
                <barcode
                  class="taki-barcode-img"
                  :value="takiForm.serialNumber"
                  format="CODE128"
                  width="1.5"
                  :displayValue="false"
                />
                <div class="title font-weight-bold mt-1">{{ takiForm.serialNumber }}</div>
              </div>
            </v-flex>
            <!-- Sağ: Webcam -->
            <v-flex xs12 md6 class="pl-3">
              <div class="caption grey--text mb-1">Ürün Fotoğrafı</div>
              <webcam-capture
                v-if="takiDialog"
                ref="webcam"
                @captured="onPhotoCaptured"
              ></webcam-capture>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn v-if="takiForm.serialNumber" color="primary" @click="printTakiCertificate">
            <v-icon left>print</v-icon>
            Yazdır
          </v-btn>
          <v-btn text color="grey" @click="closeTakiDialog">İptal</v-btn>
          <v-btn color="teal" dark :loading="takiSaving" :disabled="!takiForm.photoBase64 || takiForm.photoBase64.trim() === ''" @click="saveTaki">
            <v-icon left>save</v-icon>
            Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import WebcamCapture from "@/components/WebcamCapture.vue";
import VueBarcode from "vue-barcode";
import inventoryApi from "@/api/inventory";
import { readScaleWeight } from "@/utils/scaleSerial";
import apiSettings from "@/api/appSettings";

export default {
  components: { WebcamCapture, barcode: VueBarcode },
  data: () => ({
    loading: false,
    inventoryItems: [],
    totalHas: 0,
    headers: [
      { text: "Tip", value: "inventoryTypeName" },
      { text: "Ürün", value: "productName" },
      { text: "Ağırlık", value: "weight" },
      { text: "Ayar", value: "purityLabel" },
      { text: "Ölçü", value: "size" },
      { text: "Has", value: "hasPerUnit" },
      { text: "Adet", value: "quantity" },
      { text: "Toplam Has", value: "totalHas" },
      { text: "", value: "actions", sortable: false },
    ],

    // Külçe
    kulceDialog: false,
    kulceSaving: false,
    kulceForm: {
      selectedProduct: null,
      selectedPurity: null,
      quantity: 1,
    },
    kulceProducts: [
      { label: "0.5 gr", weight: 0.5 },
      { label: "1 gr", weight: 1 },
      { label: "2 gr", weight: 2 },
      { label: "5 gr", weight: 5 },
      { label: "10 gr", weight: 10 },
      { label: "20 gr", weight: 20 },
    ],
    kulcePurities: [
      { label: "24 Ayar 995", value: 995 },
      { label: "24 Ayar 1000", value: 1000 },
    ],

    // Ziynet
    ziynetDialog: false,
    ziynetSaving: false,
    ziynetForm: {
      selectedProduct: null,
      quantity: 1,
    },
    ziynetProducts: [
      { label: "Çeyrek", name: "Çeyrek", weight: 1.75, purity: 916.6 },
      { label: "Yarım", name: "Yarım", weight: 3.50, purity: 916.6 },
      { label: "Tam", name: "Tam", weight: 7.00, purity: 916.6 },
      { label: "Ata Lira", name: "Ata Lira", weight: 7.216, purity: 916.6 },
    ],

    // Takı
    takiDialog: false,
    takiSaving: false,
    scaleLoading: false,
    takiForm: {
      selectedProduct: null,
      selectedSize: null,
      selectedPurity: null,
      weight: null,
      serialNumber: null,
      photoBase64: null,
    },
    takiProducts: [
      "Bilezik",
      "Burma Bilezik",
      "2li Burma Bilezik",
      "3lü Burma Bilezik",
      "2li Burma Çocuk Bilezik",
      "3lü Burma Çocuk Bilezik",
      "Setina Çocuk Bilezik",
      "Ajda Bilezik",
      "Oluklu Ajda Bilezik",
      "Tel Bilezik",
      "Setina Bilezik",
      "Taşlı Kolye",
      "Küpe",
      "Küpe Ucu",
    ],
    takiSizes: [
      "6.0", "6.2", "6.4", "6.6", "6.8",
      "7.0", "7.2", "7.4", "7.6", "7.8",
      "8.0", "8.2", "8.4", "8.6", "8.8", "9.0",
    ],
    takiPurities: [
      { label: "22 Ayar", value: 916.6 },
      { label: "18 Ayar", value: 750 },
    ],
    hasFiyat: null,
  }),

  computed: {
    kulceHas() {
      if (!this.kulceForm.selectedProduct || !this.kulceForm.selectedPurity) return "";
      const w = this.kulceForm.selectedProduct.weight;
      const p = this.kulceForm.selectedPurity.value;
      return (w * (p / 1000)).toFixed(4);
    },
    ziynetHas() {
      if (!this.ziynetForm.selectedProduct) return "";
      const w = this.ziynetForm.selectedProduct.weight;
      const p = this.ziynetForm.selectedProduct.purity;
      return (w * (p / 1000)).toFixed(4);
    },
    takiHas() {
      if (!this.takiForm.weight || !this.takiForm.selectedPurity) return "";
      return (this.takiForm.weight * (this.takiForm.selectedPurity.value / 1000)).toFixed(4);
    },
    takiRoundingDifferenceText() {
      if (!this.takiForm.weight || !this.takiForm.selectedPurity || !this.hasFiyat || this.hasFiyat <= 0) return "";
      const w = parseFloat(this.takiForm.weight);
      const rounded = Math.round(w);
      const diffGr = rounded - w;
      if (Math.abs(diffGr) < 0.0001) return "";
      const p = this.takiForm.selectedPurity.value;
      const diffHas = diffGr * (p / 1000);
      const diffTl = (diffHas * this.hasFiyat).toFixed(2);
      return `Yuvarlama: ${w} gr → ${rounded} gr, fark ${diffGr.toFixed(2)} gr (has: ${diffHas.toFixed(4)}). Fark: ${diffTl} TL`;
    },
  },

  methods: {
    async loadData() {
      this.loading = true;
      try {
        const [itemsRes, hasRes] = await Promise.all([
          this.$store.dispatch("inventory/getInventoryItems"),
          this.$store.dispatch("inventory/getTotalHas"),
        ]);
        this.inventoryItems = itemsRes;
        this.totalHas = hasRes;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Envanter yüklenemedi:", e);
      } finally {
        this.loading = false;
      }
    },

    goToJewelryList(item) {
      const query = {};
      if (item && item.size) query.size = item.size;
      if (item && item.weight != null) query.weightRounded = Math.round(item.weight);
      if (item && item.purity != null) query.purity = item.purity;
      if (item && item.purityLabel) query.purityLabel = item.purityLabel;
      this.$router.push({ path: "/admin/inventory/jewelry", query });
    },

    // --- Külçe ---
    async saveKulce() {
      if (!this.kulceForm.selectedProduct || !this.kulceForm.selectedPurity || !this.kulceForm.quantity) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen tüm alanları doldurun.";
        return;
      }
      this.kulceSaving = true;
      try {
        await this.$store.dispatch("inventory/addKulce", {
          productName: this.kulceForm.selectedProduct.label,
          weight: this.kulceForm.selectedProduct.weight,
          purity: this.kulceForm.selectedPurity.value,
          purityLabel: this.kulceForm.selectedPurity.label,
          quantity: this.kulceForm.quantity,
        });
        this.kulceDialog = false;
        this.kulceForm = { selectedProduct: null, selectedPurity: null, quantity: 1 };
        this.$store.state.dialog = true;
        this.$store.state.message = "Külçe başarıyla eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.kulceSaving = false;
      }
    },

    // --- Ziynet ---
    async saveZiynet() {
      if (!this.ziynetForm.selectedProduct || !this.ziynetForm.quantity) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen tüm alanları doldurun.";
        return;
      }
      this.ziynetSaving = true;
      try {
        await this.$store.dispatch("inventory/addZiynet", {
          productName: this.ziynetForm.selectedProduct.name,
          quantity: this.ziynetForm.quantity,
        });
        this.ziynetDialog = false;
        this.ziynetForm = { selectedProduct: null, quantity: 1 };
        this.$store.state.dialog = true;
        this.$store.state.message = "Ziynet başarıyla eklendi.";
        await this.loadData();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.ziynetSaving = false;
      }
    },

    // --- Takı ---
    openTakiDialog() {
      this.takiForm = {
        selectedProduct: null,
        selectedSize: null,
        selectedPurity: null,
        weight: null,
        serialNumber: null,
        photoBase64: null,
      };
      this.takiDialog = true;
    },
    closeTakiDialog() {
      this.takiDialog = false;
    },
    async readScaleForTaki() {
      this.scaleLoading = true;
      try {
        const data = await readScaleWeight({ requestPortIfNeeded: true });
        if (data.success) {
          this.takiForm.weight = data.weight;
        } else {
          this.takiForm.weight = 0;
          this.$store.state.dialog = true;
          this.$store.state.message = data.message || "Teraziden veri okunamadı.";
        }
      } catch (e) {
        this.takiForm.weight = 0;
        this.$store.state.dialog = true;
        this.$store.state.message = (e && e.message) || "Terazi bağlantı hatası.";
      } finally {
        this.scaleLoading = false;
      }
    },
    onPhotoCaptured(base64) {
      this.takiForm.photoBase64 = base64;
    },
    printTakiCertificate() {
      const photoSrc = this.takiForm.photoBase64
        ? "data:image/jpeg;base64," + this.takiForm.photoBase64
        : null;
      const certData = {
        productName: this.takiForm.selectedProduct,
        size: this.takiForm.selectedSize,
        weight: this.takiForm.weight,
        purityLabel: this.takiForm.selectedPurity ? this.takiForm.selectedPurity.label : null,
        serialNumber: this.takiForm.serialNumber,
        photoSrc,
      };
      localStorage.setItem("jewelryCertificateData", JSON.stringify(certData));
      window.open("/print/jewelry-certificate", "_blank", "noopener,noreferrer");
    },
    async saveTaki() {
      if (!this.takiForm.selectedProduct || !this.takiForm.selectedSize ||
          !this.takiForm.selectedPurity || this.takiForm.weight == null) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen tüm alanları doldurun ve tartımı okuyun.";
        return;
      }
      if (!this.takiForm.photoBase64 || this.takiForm.photoBase64.trim() === "") {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen ürün fotoğrafı çekin.";
        return;
      }
      this.takiSaving = true;
      try {
        const result = await this.$store.dispatch("inventory/addTaki", {
          productName: this.takiForm.selectedProduct,
          size: this.takiForm.selectedSize,
          purity: this.takiForm.selectedPurity.value,
          purityLabel: this.takiForm.selectedPurity.label,
          weight: this.takiForm.weight,
          photoBase64: this.takiForm.photoBase64 || null,
        });
        this.takiForm.serialNumber = result.serialNumber;
        this.$store.state.dialog = true;
        this.$store.state.message = `Takı eklendi. Seri No: ${result.serialNumber}`;
        await this.loadData();
        // Dialog açık bırak ki seri no ve barkod görünsün
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Hata: " + (e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message);
      } finally {
        this.takiSaving = false;
      }
    },
  },

  async mounted() {
    try {
      const configRes = await apiSettings.getConfig();
      if (configRes.data && configRes.data.hasFiyat != null) {
        this.hasFiyat = parseFloat(configRes.data.hasFiyat) || null;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Config alınamadı:", e);
    }
    await this.loadData();
  },
};
</script>

<style scoped>
.taki-barcode-box {
  border: 1px solid #ccc;
  border-radius: 4px;
}
.taki-barcode-img {
  display: block;
  margin: 4px auto;
}
</style>
